<!-- =========================================================================================
    File Name: FormValidationMultipleRules.vue
    Description: Simple form validation
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vx-card title="Change Password">
    <div class="mt-5">
      <form>
        <div class="vx-row lg:w-1/2 w-full">

          <div class="vx-col lg:w-1/2 w-full mt-5">
            <label class="text-sm">Current Password</label >
            <vs-input
              data-vv-as="Current password"

              type="password" v-validate="'required|min:6|max:10'" ref="password" placeholder="Current password"
                      name="password" v-model="model.old" class=" w-full"/>
            <span class="text-danger text-sm" v-show="errors.has('password')">{{ errors.first('password') }}</span>
          </div>

          <div class="vx-col lg:w-1/2 w-full"></div>

          <div class="vx-col lg:w-1/2 w-full mt-5">
            <label  class="text-sm">New password</label >

            <vs-input
              data-vv-as="New password"

              type="password" v-validate="'required|min:6|max:10'" ref="password" placeholder="New password"
                      name="new" v-model="model.new" class=" w-full"/>
            <span class="text-danger text-sm" v-show="errors.has('new')">{{ errors.first('new') }}</span>
          </div>

          <div class="vx-col lg:w-1/2 w-full mt-5">
            <label class="text-sm">Repeat password</label >

            <vs-input
              data-vv-as="Repeat password"

              type="password" v-validate="'required|min:6|max:10|confirmed:password'"
                      placeholder="Repeat password" name="confirm_password" v-model="model.confirm"
                      class="w-full"/>
            <span class="text-danger text-sm" v-show="errors.has('confirm_password')">{{ errors.first('confirm_password') }}</span>
          </div>

        </div>
        <vs-button type="filled" @click.prevent="submitForm" class="mt-5 block">Change Password</vs-button>
      </form>
    </div>
  </vx-card>
</template>

<script>
  import axios from '@/axios.js'

  export default {
    name: 'PasswordForm',
    data() {
      return {
        model: {},
      }
    },
    methods: {
      submitForm() {
        this.$validator.validateAll().then(async result => {
          if (result) {
            this.$vs.loading();
            try {
              await axios.post("/customer/change-password", this.model);
              this.model = {};
              this.$vs.notify({
                title:'Password Changed',
                text:'Your password has been successfully changed',
                color:'success'
              })
              this.$vs.loading.close();
            } catch (e) {
              console.log('e' , e.data);
              this.$vs.notify({
                title:'Error',
                text:e.response.data.message||'Unexpected error',
                color:'danger'
              })
              this.$vs.loading.close();
            }
          }
        })
      }
    },
  }
</script>
